import type { User } from 'types/user';

const BANCA_SESSION_KEY = 'bb.banca-session';

/**
 * Identifica usuários da banca técnica externa.
 *
 * Fonte primária da verdade: a flag `bb.banca-session` no localStorage,
 * setada por `LoginPublic` quando o login acontece via `/login-banca`.
 * Fallback: `_id` contém `@` (banca registra com email como _id em alguns
 * ambientes). Combinar os dois cobre tanto o usuário ainda autenticado
 * quanto cenários em que `_id` é numérico no Funifier.
 */
export const isBancaUser = (
  user?: Pick<User, '_id'> | null
): boolean => {
  try {
    if (typeof window !== 'undefined' &&
        window.localStorage.getItem(BANCA_SESSION_KEY) === '1') {
      return true;
    }
  } catch {
    /* ignora — fallback para a heurística do _id */
  }
  return Boolean(user?._id && user._id.includes('@'));
};
